module.exports = __webpack_public_path__ + "img/Super_Rent_Logo_Dark.ee574013.svg";